import { useContext, useEffect, useState } from 'react'
import UploadProfile from './UploadProfile'
import { PersonalInfo } from './PersonalInfo'
import { Language } from './Languages'
import { Disability } from './Disability'
import { Layout } from './Layout'
import { compressImage } from "../../../utils/compressImage"
import { firstNameValidator, lastNameValidator, fullNameValidator, emailValidator, contactValidator } from "../../../utils/validator"
import { DataProvider } from '../../../store/ContextProvider'
import { useLocation, useNavigate } from 'react-router-dom'

export const PersonalData = ({ candidate, fetchCandidateData }) => {
    const { BeURL, currentUser } = useContext(DataProvider)
    const [profile, setProfile] = useState({})
    const [profileInformation, setProfileInformation] = useState({})
    const [, setLanguage] = useState([])
    const [disability, setDisability] = useState({})
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()

    // fetch the query:;

    const location = useLocation()
    const queryFetch = new URLSearchParams(location.search)
    const reverse = queryFetch.get('inverse') === "true"
    const previous = location.state?.from || '/account'


    useEffect(() => {
        fetchCandidateData()
    }, [])

    const [errors, setErrors] = useState({});

    const handleProfile = (value) => {
        setProfile(value)
    }
    const handleProfileInformation = (value) => {
        setProfileInformation(value)
    }
    const handleLanguage = (value) => {
        if (value && Array.isArray(value) && value.length) {
            setLanguage(value)
        }
    }
    const handleDisability = (value) => {
        setDisability(value)
    }

    const checkValidation = (field, value, label) => {
        const e = {};

        if (field === "firstname") {
            e[field] = firstNameValidator(value) ? firstNameValidator(value) : ""
        }

        if (field === "lastname") {
            e[field] = (!value) ? "This field is required." : (lastNameValidator(value) || "")
        }

        if (field === "fullname") {
            e[field] = fullNameValidator(value) ? fullNameValidator(value) : ""
        }

        if (field === "email") {
            e[field] = emailValidator(value) ? emailValidator(value) : ""
        }

        if (field === "alternateemail") {
            if (value.toLowerCase() === profileInformation.email.toLowerCase()) {
                e[field] = "Alternate email cannot be same as primary email."
            }
            else {
                e[field] = (value && emailValidator(value)) ? emailValidator(value) : ""
            }
        }

        if (label === "contact") {
            if (field === "countryCode") {
                e.contactCode = (!value) ? "Kindly select any option." : ""
            }
            else if (field === "number") {
                e.contactNumber = contactValidator(value) ? contactValidator(value) : ""
            }
        }

        if (label === "alternatecontact") {
            if (field === "countryCode") {
                e.alternateContactCode = (!value) ? "Kindly select any option." : ""
            }
            else if (field === "number") {
                if (profileInformation.contact?.number === value) {
                    e.alternateContactNumber = "Alternate contact cannot be same as primary contact."
                }
                else {
                    e.alternateContactNumber = (value) ? (contactValidator(value) || "") : ""
                }
            }
        }

        if (["gender", "dob", "maritalstatus"].includes(field)) {
            e[field] = (!value) ? "This field is required." : ""
        };

        setErrors(prev => {
            let tempError = { ...prev } || {}
            if (Object.keys(e).length) {
                Object.keys(e).forEach(key => {
                    tempError[key] = e[key]
                })
            }
            return tempError
        })

        const errs = Object.values(e).filter(err => err !== "") || []

        return errs.length > 1 ? true : false
    }

    const handleValidation = () => {
        let errStatus = []

        const { firstname, middlename, lastname, fullname, email, alternateemail, contact, alternatecontact, dob, gender, maritalstatus } = profileInformation
        const structureProfile = { firstname, middlename, lastname, fullname, email, alternateemail, dob, gender, maritalstatus }

        Object.keys(structureProfile).forEach(key => {
            errStatus.push(checkValidation(key, structureProfile[key]))
        })

        errStatus.push(checkValidation("countryCode", contact["countryCode"], "contact"))
        errStatus.push(checkValidation("number", contact["number"], "contact"))
        errStatus.push(checkValidation("countryCode", alternatecontact["countryCode"], "alternatecontact"))
        errStatus.push(checkValidation("number", alternatecontact["number"], "alternatecontact"))

        if (disability.isDisabled && !disability.desc) {
            errStatus.push(true)
            alert("Kindly describe your disability!")
        }

        return errStatus.some(err => err === true)
    }

    const handleSubmit = async () => {
        setLoading(true)
        const Errors = Object.values(errors).filter(Boolean);
        if (handleValidation() || Errors.length) {
            alert("Kindly fill all details!")
            setLoading(false)
            return
        }

        const formData = new FormData();
        formData.append("profileInformation", JSON.stringify(profileInformation));
        formData.append("disability", JSON.stringify(disability));

        if (profile) {
            const compressedFile = await compressImage(profile, { maxSizeMB: 0.7 });
            if (compressedFile) {
                formData.append("profile", compressedFile);
            }
        }

        fetch(`${BeURL}/candidate-personal-info`, {
            method: "POST",
            credentials: 'include',
            body: formData
        })
            .then(res => res.json())
            .then(data => {
                setLoading(false)
                if (data.success) {
                    navigate(`/update-account/profilesummery?userId=${currentUser?._id}`)
                    if (reverse)
                        navigate(previous)
                }
                else {
                    alert(data.message)
                }
            })
            .catch(err => {
                setLoading(false)
                console.log("Error in submitting Candidate personal information:", err)
                alert("Trouble in connnecting to the Server! kindly try again later.")
            })
    }
    return (
        <Layout candidate={candidate}>
            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-4 md:py-8 lg:mb-0 mb-14'>
                <div>
                    <UploadProfile setProfile={handleProfile} url={candidate.profilePicLink || ""} />
                </div>
                <div>
                    <PersonalInfo Information={handleProfileInformation} errors={errors} checkValidation={checkValidation} candidate={candidate} />
                </div>
                <Language Information={handleLanguage} errors={errors} setErrors={setErrors} candidate={candidate} />
                <div>
                    <Disability Information={handleDisability} errors={errors} setErrors={setErrors} candidate={candidate} />
                </div>

                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full my-4">
                    <button onClick={() => navigate(`/update-account/skills?userId=${currentUser?._id}`)}
                        className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium  transition text-center">
                        Previous
                    </button>
                    <button
                        type="button"
                        onClick={handleSubmit}
                        disabled={loading}
                        className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
                    >
                        {reverse ? 'Update' : (loading ? 'Saving...' : 'Next')}
                    </button>
                </div>
            </div>
        </Layout>
    )
}
